'use strict';

angular.module('webAgro1App').controller('DepositoCtrl', function ($location, $scope, $routeParams, $rootScope, DepositosService, Flash,
  LoadingService, MessagesService) {

  var initialize = function() {
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.depositos.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.deposito = [];
      LoadingService.showLoading();
      DepositosService.get($routeParams.id).then(function(deposito) {
        $scope.deposito = deposito.data;
      }, function() {
        MessagesService.error('Erro', 'Erro ao recuperar dados, tente novamente.');
      }).finally(LoadingService.hideLoading);

    }, $rootScope.errorRootInitialize);
  };

  initialize();

  $scope.goToIndex = function() {
    $location.path('/depositos');
  };

  $scope.edit = function() {
    $location.path('/depositos/' + $scope.deposito.cd_deposito + '/edit');
  };

});
